/* eslint-disable react/no-array-index-key */
import React, { useRef } from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import _ from 'lodash';
import QuestionHeader from '../QuestionHeader';
import AudioButton from '../AudioButton';

const SelectWordsInSentence = ({ data, onSubmit, userData, questionIndex = 0 }) => {
  const [state, setState] = React.useState({
    data: null,
    words: [],
    selectedAnswers: [],
  });

  const ref = useRef();
  ref.current = new Audio();

  const playAudio = React.useCallback((audioUrl) => {
    ref.current.src = audioUrl;
    ref.current.play();
  }, []);

  ref.current.addEventListener('ended', () => {
    // setState((prevState) => ({ ...prevState, isAudioPlaying: false }));
  });

  React.useEffect(() => {
    const words = data.answers.map((item, index) => {
      return { id: index + 1, text: item.answer, isCorrect: item.isCorrect };
    });
    if (userData) {
      setState((prevState) => ({ ...prevState, words, data, selectedAnswers: userData.answers }));
    } else {
      setState((prevState) => ({ ...prevState, words, data }));
    }
  }, [data, userData]);

  if (!data) return null;

  return (
    <Card>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='SelectWordsInSentence' />
      </CardHeader>
      <CardBody style={{ minHeight: 300 }}>
        <div className='questionText'>{data.question}</div>

        <AudioButton audioUrl={data.audioUrl} />
        <div className='d-flex flex-wrap mt-4'>
          {state.words.map((word, index) => {
            const found = _.find(state.selectedAnswers, (x) => {
              return x.id === word.id;
            });
            return (
              <Button
                // size='small'
                key={`word-${index}`}
                color={found === undefined ? 'secondary' : 'success'}
                onClick={() => {
                  // let found = _.find(state.selectedAnswers, (x) => {
                  //   return x.id === word.id;
                  // });

                  if (found === undefined) {
                    const array = [...state.selectedAnswers];
                    array.push(word);
                    setState((prevState) => ({ ...prevState, selectedAnswers: array }));
                  } else {
                    const array = _.filter(state.selectedAnswers, (x) => x.id !== word.id);
                    setState((prevState) => ({ ...prevState, selectedAnswers: array }));
                  }
                }}
                style={{
                  padding: 8,
                  cursor: 'pointer',
                  fontWeight: 600,
                  marginLeft: 0,
                  marginRight: 8,
                  marginBottom: 8,
                }}
              >
                {word.text}
              </Button>
            );
          })}
        </div>
      </CardBody>

      <CardFooter>
        {
          <Button
            color='primary'
            disabled={state.selectedAnswers.length < 1}
            onClick={() => {
              if (userData) {
                onSubmit({ id: state.data.id, answers: state.selectedAnswers });
              }
              const correctAnswers = _.filter(state.words, (x) => x.isCorrect === true);
              const result = _.isEqual(_.sortBy(correctAnswers, ['id']), _.sortBy(state.selectedAnswers, ['id']));
              // Callback
              if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers: state.selectedAnswers, result });
            }}
          >
            Submit
            <i className='fas fa-arrow-right ml-3' />
          </Button>
        }
      </CardFooter>
    </Card>
  );
};

export default SelectWordsInSentence;
